import images_abraLogoFragmentSvg from "../images/abra_logo_fragment.svg";
import images_abraLogoFullSvg from "../images/abra_logo_full.svg";
import images_abraLogoLettersSvg from "../images/abra_logo_letters.svg";
import images_accountActiveSvg from "../images/account-active.svg";
import images_accountMultipleSvg from "../images/account-multiple.svg";
import images_accountMultipleActiveSvg from "../images/account-multiple_active.svg";
import images_accountSvg from "../images/account.svg";
import images_addSvg from "../images/add.svg";
import images_arrowUpSvg from "../images/arrow-up.svg";
import images_arrowUpActiveSvg from "../images/arrow-up_active.svg";
import images_attachmentsSvg from "../images/attachments.svg";
import images_attachmentsLineSvg from "../images/attachments_line.svg";
import images_attachmentsLineActiveSvg from "../images/attachments_line_active.svg";
import images_avatarSvg from "../images/avatar.svg";
import images_avatarPhoneSvg from "../images/avatar_phone.svg";
import images_cancelSvg from "../images/cancel.svg";
import images_checkWhiteSvg from "../images/check-white.svg";
import images_checkSvg from "../images/check.svg";
import images_checkedSvg from "../images/checked.svg";
import images_chevronLeftSvg from "../images/chevron-left.svg";
import images_chevronRightSvg from "../images/chevron-right.svg";
import images_closeSvg from "../images/close.svg";
import images_closeWhiteSvg from "../images/close_white.svg";
import images_closedTasksSvg from "../images/closed_tasks.svg";
import images_commentSvg from "../images/comment.svg";
import images_commentActiveSvg from "../images/comment_active.svg";
import images_csSvg from "../images/cs.svg";
import images_deSvg from "../images/de.svg";
import images_delayedTasksSvg from "../images/delayed_tasks.svg";
import images_deleteSvg from "../images/delete.svg";
import images_deleteItemSvg from "../images/delete_item.svg";
import images_enSvg from "../images/en.svg";
import images_editSvg from "../images/edit.svg";
import images_fileSvg from "../images/file.svg";
import images_filterSvg from "../images/filter.svg";
import images_filterActiveSvg from "../images/filter_active.svg";
import images_filterAltSvg from "../images/filter_alt.svg";
import images_handPointingDownSvg from "../images/hand-pointing-down.svg";
import images_handPointingUpSvg from "../images/hand-pointing-up.svg";
import images_helpSvg from "../images/help.svg";
import images_infoSvg from "../images/info.svg";
import images_infoActiveSvg from "../images/info_active.svg";
import images_logoutSvg from "../images/logout.svg";
import images_menuDownSvg from "../images/menu-down.svg";
import images_menuUpSvg from "../images/menu-up.svg";
import images_menuSvg from "../images/menu.svg";
import images_moreVertSvg from "../images/more_vert.svg";
import images_myTasksSvg from "../images/my_tasks.svg";
import images_notificationsSvg from "../images/notifications.svg";
import images_notificationsActiveSvg from "../images/notifications_active.svg";
import images_notificationsFullSvg from "../images/notifications_full.svg";
import images_notificationsLineSvg from "../images/notifications_line.svg";
import images_notificationsLineActiveSvg from "../images/notifications_line_active.svg";
import images_ownedTasksSvg from "../images/owned_tasks.svg";
import images_plusCircleOutlinePng from "../images/plus-circle-outline.png";
import images_plusCircleOutlineSvg from "../images/plus-circle-outline.svg";
import images_plusSvg from "../images/plus.svg";
import images_priorityHighSvg from "../images/priority-high.svg";
import images_priorityLowSvg from "../images/priority-low.svg";
import images_priorityMediumSvg from "../images/priority-medium.svg";
import images_relationsSvg from "../images/relations.svg";
import images_relationsLineSvg from "../images/relations_line.svg";
import images_relationsLineActiveSvg from "../images/relations_line_active.svg";
import images_resolvedTasksSvg from "../images/resolved_tasks.svg";
import images_searchSvg from "../images/search.svg";
import images_settingsSvg from "../images/settings.svg";
import images_settingsActiveSvg from "../images/settings_active.svg";
import images_skSvg from "../images/sk.svg";
import images_sortAscendingSvg from "../images/sort-ascending.svg";
import images_sortDescendingSvg from "../images/sort-descending.svg";
import images_spinnerGraySvg from "../images/spinner_gray.svg";
import images_spinnerWhiteSvg from "../images/spinner_white.svg";
import images_taskAddedSvg from "../images/task-added.svg";
import images_taskAddedActiveSvg from "../images/task-added_active.svg";
import images_taskAssignedSvg from "../images/task-assigned.svg";
import images_taskAssignedActiveSvg from "../images/task-assigned_active.svg";
import images_taskCommentedSvg from "../images/task-commented.svg";
import images_taskCommentedActiveSvg from "../images/task-commented_active.svg";
import images_taskDeadlineSvg from "../images/task-deadline.svg";
import images_taskDeadlineActiveSvg from "../images/task-deadline_active.svg";
import images_taskDeletedSvg from "../images/task-deleted.svg";
import images_taskDeletedActiveSvg from "../images/task-deleted_active.svg";
import images_taskDoneSvg from "../images/task-done.svg";
import images_taskEditedSvg from "../images/task-edited.svg";
import images_taskEditedActiveSvg from "../images/task-edited_active.svg";
import images_taskWarningSvg from "../images/task-warning.svg";
import images_tasksAllSvg from "../images/tasks-all.svg";
import images_tasksAllActiveSvg from "../images/tasks-all_active.svg";
import images_timerSvg from "../images/timer.svg";
import images_unfoldLessSvg from "../images/unfold-less.svg";
import images_unfoldMoreSvg from "../images/unfold-more.svg";

export default {
  abraLogoFragmentSvg: images_abraLogoFragmentSvg,
  abraLogoFullSvg: images_abraLogoFullSvg,
  abraLogoLettersSvg: images_abraLogoLettersSvg,
  accountActiveSvg: images_accountActiveSvg,
  accountMultipleSvg: images_accountMultipleSvg,
  accountMultipleActiveSvg: images_accountMultipleActiveSvg,
  accountSvg: images_accountSvg,
  addSvg: images_addSvg,
  arrowUpSvg: images_arrowUpSvg,
  arrowUpActiveSvg: images_arrowUpActiveSvg,
  attachmentsSvg: images_attachmentsSvg,
  attachmentsLineSvg: images_attachmentsLineSvg,
  attachmentsLineActiveSvg: images_attachmentsLineActiveSvg,
  avatarSvg: images_avatarSvg,
  avatarPhoneSvg: images_avatarPhoneSvg,
  cancelSvg: images_cancelSvg,
  checkWhiteSvg: images_checkWhiteSvg,
  checkSvg: images_checkSvg,
  checkedSvg: images_checkedSvg,
  chevronLeftSvg: images_chevronLeftSvg,
  chevronRightSvg: images_chevronRightSvg,
  closeSvg: images_closeSvg,
  closeWhiteSvg: images_closeWhiteSvg,
  closedTasksSvg: images_closedTasksSvg,
  commentSvg: images_commentSvg,
  commentActiveSvg: images_commentActiveSvg,
  csSvg: images_csSvg,
  deSvg: images_deSvg,
  delayedTasksSvg: images_delayedTasksSvg,
  deleteSvg: images_deleteSvg,
  deleteItemSvg: images_deleteItemSvg,
  enSvg: images_enSvg,
  editSvg: images_editSvg,
  fileSvg: images_fileSvg,
  filterSvg: images_filterSvg,
  filterActiveSvg: images_filterActiveSvg,
  filterAltSvg: images_filterAltSvg,
  handPointingDownSvg: images_handPointingDownSvg,
  handPointingUpSvg: images_handPointingUpSvg,
  helpSvg: images_helpSvg,
  infoSvg: images_infoSvg,
  infoActiveSvg: images_infoActiveSvg,
  logoutSvg: images_logoutSvg,
  menuDownSvg: images_menuDownSvg,
  menuUpSvg: images_menuUpSvg,
  menuSvg: images_menuSvg,
  moreVertSvg: images_moreVertSvg,
  myTasksSvg: images_myTasksSvg,
  notificationsSvg: images_notificationsSvg,
  notificationsActiveSvg: images_notificationsActiveSvg,
  notificationsFullSvg: images_notificationsFullSvg,
  notificationsLineSvg: images_notificationsLineSvg,
  notificationsLineActiveSvg: images_notificationsLineActiveSvg,
  ownedTasksSvg: images_ownedTasksSvg,
  plusCircleOutlinePng: images_plusCircleOutlinePng,
  plusCircleOutlineSvg: images_plusCircleOutlineSvg,
  plusSvg: images_plusSvg,
  priorityHighSvg: images_priorityHighSvg,
  priorityLowSvg: images_priorityLowSvg,
  priorityMediumSvg: images_priorityMediumSvg,
  relationsSvg: images_relationsSvg,
  relationsLineSvg: images_relationsLineSvg,
  relationsLineActiveSvg: images_relationsLineActiveSvg,
  resolvedTasksSvg: images_resolvedTasksSvg,
  searchSvg: images_searchSvg,
  settingsSvg: images_settingsSvg,
  settingsActiveSvg: images_settingsActiveSvg,
  skSvg: images_skSvg,
  sortAscendingSvg: images_sortAscendingSvg,
  sortDescendingSvg: images_sortDescendingSvg,
  spinnerGraySvg: images_spinnerGraySvg,
  spinnerWhiteSvg: images_spinnerWhiteSvg,
  taskAddedSvg: images_taskAddedSvg,
  taskAddedActiveSvg: images_taskAddedActiveSvg,
  taskAssignedSvg: images_taskAssignedSvg,
  taskAssignedActiveSvg: images_taskAssignedActiveSvg,
  taskCommentedSvg: images_taskCommentedSvg,
  taskCommentedActiveSvg: images_taskCommentedActiveSvg,
  taskDeadlineSvg: images_taskDeadlineSvg,
  taskDeadlineActiveSvg: images_taskDeadlineActiveSvg,
  taskDeletedSvg: images_taskDeletedSvg,
  taskDeletedActiveSvg: images_taskDeletedActiveSvg,
  taskDoneSvg: images_taskDoneSvg,
  taskEditedSvg: images_taskEditedSvg,
  taskEditedActiveSvg: images_taskEditedActiveSvg,
  taskWarningSvg: images_taskWarningSvg,
  tasksAllSvg: images_tasksAllSvg,
  tasksAllActiveSvg: images_tasksAllActiveSvg,
  timerSvg: images_timerSvg,
  unfoldLessSvg: images_unfoldLessSvg,
  unfoldMoreSvg: images_unfoldMoreSvg
};
